<div class="entra-config-dialog">
    <div class="title" mat-dialog-title>Entra SSO Setup Complete</div>
    <div class="dialog-body">
        <div class="success-message">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <p>Entra SSO is setup successfully, it may take up to 15 mins to get ready.</p>
        </div>

        <p class="instructions">Please complete the following steps to finish the setup:</p>

        <div class="steps-container">
            <div class="step">
                <div class="step-header">
                    <span class="step-number">1</span>
                    <span class="step-title">Add Callback URL to Entra</span>
                </div>
                <div class="step-content">
                    <p>Copy the callback URL below and add it to your registered app in Entra:</p>
                    <div class="url-box">
                        <code>https://{{payload.shortname}}.sso.{{domain}}/oauth2/idpresponse</code>
                    </div>
                    <p class="step-link">
                        <a href="https://entra.microsoft.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade/quickStartType~/null/sourceType/Microsoft_AAD_IAM" target="_blank" rel="noopener noreferrer">Open Entra App Registration</a>
                    </p>
                </div>
            </div>

            <div class="step">
                <div class="step-header">
                    <span class="step-number">2</span>
                    <span class="step-title">Share Login URL with Users</span>
                </div>
                <div class="step-content">
                    <p>Share the login URL below with your users to enable SSO login:</p>
                    <div class="url-box">
                        <code>https://{{payload.shortname}}.{{domain}}</code>
                    </div>
                    <p class="step-info">All users can use this URL to login via Entra SSO.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button mat-raised-button color="primary" [mat-dialog-close]="true">Done</button>
    </div>
</div>
